import React from 'react';

// Minimaler Status-/Reconnect-Baustein fuer die IBKR-Gateway-Anbindung
// (Phase 1, Chat vom 2026-08-03) - zeigt an, ob das Gateway verbunden ist,
// und bietet den manuellen Reconnect-Trigger fuer den woechentlichen
// Sonntags-2FA-Reset (siehe IbGatewayStatus.inc/IbGatewayReconnect.inc).
// Bewusst nur ein kleines Badge, kein eigenes Modul - volles Order-UI folgt
// erst in Phase 2.
// variant='nav': kompakter Statuspunkt als Overlay am IB-Icon der Top-Navigation
// (Chat vom 2026-08-12) - gruen=verbunden, rot=getrennt (Klick auf Rot startet
// Reconnect). Ersetzt den frueheren Status-Punkt in der Marktdaten-Kopfzeile,
// dessen zusaetzlicher Reconnect-Pfeil dort wie ein zweiter Reload-Button wirkte.
function IbGatewayStatusBadge({ x, variant }) {
	const [status, setStatus] = React.useState(null);
	const [reconnecting, setReconnecting] = React.useState(false);

	const loadStatus = React.useCallback(() => {
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=IbGatewayStatus', {}, (result) => {
			if (result.data.returncode === 1) {
				setStatus(result.data.content);
			}
		});
	}, [x]);

	React.useEffect(() => {
		loadStatus();
		const timer = setInterval(loadStatus, 30000);
		return () => clearInterval(timer);
	}, [loadStatus]);

	function handleReconnect() {
		setReconnecting(true);
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=IbGatewayReconnect', {}, () => {
			setReconnecting(false);
			// Verbindungsaufbau braucht einen Moment (Login + ggf. 2FA-Warten) -
			// Status-Anzeige etwas verzoegert nachladen statt sofort (waere noch
			// der alte Stand).
			setTimeout(loadStatus, 5000);
		});
	}

	if (status === null) {
		return null;
	}

	if (variant === 'nav') {
		return (
			<span
				className={'ib-gateway-nav-status ' + (status.connected ? 'ib-gateway-nav-connected' : 'ib-gateway-nav-disconnected') + (reconnecting ? ' ib-gateway-nav-reconnecting' : '')}
				title={status.connected ? 'IB-Gateway verbunden' : 'IB-Gateway nicht verbunden – klicken zum Neuverbinden (z.B. wöchentlicher Sonntags-Reset)'}
				onClick={status.connected || reconnecting ? undefined : handleReconnect}
			/>
		);
	}

	return (
		<span className="module-table-title-toolbar" title={status.connected ? 'IB-Gateway verbunden' : 'IB-Gateway nicht verbunden - z.B. woechentlicher Sonntags-Reset noch offen'}>
			<i className={'bi bi-circle-fill me-1 ' + (status.connected ? 'text-success' : 'text-danger')} style={{ fontSize: '0.6rem' }} />
			{!status.connected && (
				<i
					className={'bi bi-arrow-repeat module-icon' + (reconnecting ? ' disabled' : '')}
					title="IB-Gateway neu verbinden"
					onClick={reconnecting ? undefined : handleReconnect}
				/>
			)}
		</span>
	);
}

export default IbGatewayStatusBadge;
